"use client"

export type FilterValue = "all" | "ongoing" | "upcoming" | "expired"

interface Filter {
    id: FilterValue
    label: string
}

interface FilterButtonsProps {
    filters: Filter[]
    currentFilter: FilterValue
    onFilterChange: (filter: FilterValue) => void
}

export const FilterButtons = ({ filters, currentFilter, onFilterChange }: FilterButtonsProps) => {
    return (
        <div className="flex gap-2.5 overflow-x-auto">
            {filters.map((f) => (
                <button
                    key={f.id}
                    onClick={() => onFilterChange(f.id)}
                    className={`sm:text-base text-xs leading-[32px] font-semibold px-[18px] rounded-full transition-all duration-300 whitespace-nowrap flex-shrink-0 ${currentFilter === f.id
                        ? "bg-[#18af4e] text-white"
                        : "bg-[#f3f3f3] text-[#333] hover:text-[#18af4e]"
                        }`}
                >
                    {f.label}
                </button>
            ))}
        </div>
    )
}

